module.exports = __webpack_public_path__ + "static/img/Icon3.f80f2d6b.svg";